import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SharedTrip from "./pages/SharedTrip";
import Destinations from "./pages/Destinations";
import DestinationGuide from "./pages/DestinationGuide";
import TravelGuide from "./pages/TravelGuide";
import Planner from "./pages/Planner";
import SavedTrips from "./pages/SavedTrips";
import TripView from "./pages/TripView";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Refunds from "./pages/Refunds";
import PlanWithUs from "./pages/PlanWithUs";
import Features from "./pages/Features";
import PublicTrip from "./pages/PublicTrip";
import { lazy, Suspense } from "react";
const AdminDashboard = lazy(() => import("./pages/admin/AdminDashboard"));
const AdminPeople = lazy(() => import("./pages/admin/AdminPeople"));
const AdminPerson = lazy(() => import("./pages/admin/AdminPerson"));
const AdminList = lazy(() => import("./pages/admin/AdminList"));
const A = ({ children }) => <Suspense fallback={null}>{children}</Suspense>;
import Plans from "./pages/Plans";
import PaymentSuccess from "./pages/PaymentSuccess";
import { ConsentBanner } from "./components/ConsentBanner";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/shared/:shareId" element={<SharedTrip />} />
              <Route path="/t/:slug" element={<PublicTrip />} />
              <Route path="/destinations" element={<Destinations />} />
              <Route path="/destinations/:slug" element={<DestinationGuide />} />
              <Route path="/travel-guide" element={<TravelGuide />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/refunds" element={<Refunds />} />
              <Route path="/plan-with-us" element={<PlanWithUs />} />
              <Route path="/features" element={<Features />} />
              <Route path="/plans" element={<Plans />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<Navigate to="/plans?cancelled=1" replace />} />
              <Route path="/plan" element={<Protected><Planner /></Protected>} />
              <Route path="/trips" element={<Protected><SavedTrips /></Protected>} />
              <Route path="/trips/:id" element={<Protected><TripView /></Protected>} />
              <Route path="/admin" element={<Protected><A><AdminDashboard /></A></Protected>} />
              <Route path="/admin/people" element={<Protected><A><AdminPeople /></A></Protected>} />
              <Route path="/admin/people/:id" element={<Protected><A><AdminPerson /></A></Protected>} />
              <Route path="/admin/orders" element={<Protected><A><AdminList kind="orders" /></A></Protected>} />
              <Route path="/admin/enquiries" element={<Protected><A><AdminList kind="enquiries" /></A></Protected>} />
              <Route path="/admin/contacts" element={<Protected><A><AdminList kind="contacts" /></A></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-center" richColors />
            <ConsentBanner />
          </BrowserRouter>
        </AuthProvider>
    </div>
  );
}

export default App;
